import { addAssetSubscription } from './AssetSubscriptions';
import { lazySubscribe, NotificationSubscription, lazyGetChannelId } from 'owa-notification';
import type { ProjectId } from 'owa-timestream-types';
import getAssetsFolderId from '../substrate/getAssetsFolderId';
import handleAssetNotification from './handleAssetNotification';
import subscriptionParameters from 'owa-service/lib/factory/subscriptionParameters';
import getTargetMailbox from '../substrate/getTargetMailbox';

export default async function subscribeToAssetNotifications(
    subscriptionId: string,
    projectId: ProjectId
) {
    const mailboxId = getTargetMailbox(projectId);
    const folderId = await getAssetsFolderId(projectId);

    // TODO, BUG: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/99649
    // RowNotification is not working for group mailboxes with folders other than inbox.
    // CreateRowBrokerHandler in Substrate's Owa2/Server/Core/notifications/Broker/BrokerNotificationManager.cs ignores the folder ID and uses the inbox.
    // Perhaps we can relax that restriction?
    // A more complicated solution might be to use https://docs.substrate.microsoft.net/docs/Substrate-APIs-and-services/Substrate-Data-Store-%28SDS%29/Using-the-SDS-API/Subscribing-to-change-notifications.html?uid=subscribing-to-change-notifications
    // That will require our OWS' to provide a callback handler and then forward that to an OWA session.
    // Perhaps we can leverage owa-activity-feed's subscribeToPrimeNotification?
    // For now, if there's a mailboxId assume it is for a group mailbox and do not subscribe.
    if (folderId && !mailboxId) {
        const channelId = (await lazyGetChannelId.import())();
        const notificationSubscription: NotificationSubscription = {
            subscriptionId,
            requiresExplicitSubscribe: true,
            subscriptionParameters: subscriptionParameters({
                ChannelId: channelId,
                NotificationType: 'RowNotification',
                MailboxId: mailboxId,
                FolderId: folderId,

                // TODO, BUG: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/99650
                // As much as I tried, I couldn't get the notification to send me the SDS properties, even
                // after passing ItemShapeName & ItemResponseShape
                // Either we need to find a way to do it (perhaps a bug in server code) or we need an SDS-specific notification type.
                // In the meantime, I'm forced to lookup the SDS item by its notification ID in order to get the key we use in Spaces.
                // If we build an SdsRowNotification handler we can use FolderId in SubscriptionParameter to pass the application ID and
                // the collection name then we can let the server figure out the Store FolderId, thus eliminating the getAssetsFolderId code.
            }),
        };

        addAssetSubscription(subscriptionId, projectId, notificationSubscription);
        lazySubscribe.importAndExecute(notificationSubscription, handleAssetNotification);
    }
}
